import React, { ReactElement, useContext } from 'react';
import { FilterContext } from 'components/filters/js/filter-service';
import { NoResults } from 'components/filters/js/no-results';

const SearchList = ({ startCount, totalCount }: iSearchList): ReactElement => {
    const { items, isLoading, itemsCount, pagination, appliedFilters } = useContext(FilterContext);
    const num = itemsCount !== undefined ? itemsCount : 0;
    const isNoRes = num === 1 && pagination.totalCount === 0 && startCount === 0;
    const showCount = () => {
        const isFirstLoad = num === 1 && pagination.totalCount === 0;
        return (
            <div className="search-page__statistics">
                {isFirstLoad ? (
                    <div>
                        {/* eslint-disable-next-line react/no-unescaped-entities */}
                        Showing {startCount} out of {totalCount} results for ' {appliedFilters.s} '
                    </div>
                ) : (
                    <div>
                        {/* eslint-disable-next-line react/no-unescaped-entities */}
                        Showing {pagination.currentPosts} out of {pagination.totalCount} results for '{' '}
                        {appliedFilters.s} '
                    </div>
                )}
            </div>
        );
    };

    return (isLoading && !isNoRes) || (num > 0 && !isLoading && !isNoRes) ? (
        <div className="search-page__body">
            {showCount()}
            <section className="cards-grid spinner-placeholder">
                <ul
                    className="cards-grid__list"
                    dangerouslySetInnerHTML={{ __html: items.join('') }}
                />
            </section>
        </div>
    ) : (
        <NoResults />
    );
};

interface iSearchList {
    startCount: number;
    totalCount: number;
}

export { SearchList };

